// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2wQpr","ranges":"BmiRanges_ranges__3L3Wu"};